<template>
  <v-row>
    <v-col cols="12" md="6">
      <grafico-rosca-tipos-verba
        :params="params"
      />
    </v-col>
    <v-col cols="12" md="6">
      <grafico-barras-horizontais-tipo-acao
        :params="params"
      />
    </v-col>
    <v-col cols="12" md="6">
      <grafico-barras-evolucao-mensal
        :params="params"
      />
    </v-col>
    <v-col cols="12" md="6">
      <grafico-barras-horizontais-subtipo
        :params="params"
      />
    </v-col>
  </v-row>
</template>

<script>
import GraficoRoscaTiposVerba from './GraficoRoscaTiposVerba';
import GraficoBarrasHorizontaisTipoAcao from './GraficoBarrasHorizontaisTipoAcao';
import GraficoBarrasHorizontaisSubtipo from './GraficoBarrasHorizontaisSubtipo';
import GraficoBarrasEvolucaoMensal from './GraficoBarrasEvolucaoMensal';

export default {
  name: 'ContainerGraficos',
  props: {
    filtros: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    GraficoRoscaTiposVerba,
    GraficoBarrasHorizontaisTipoAcao,
    GraficoBarrasHorizontaisSubtipo,
    GraficoBarrasEvolucaoMensal,
  },
  computed: {
    params() {
      const params = {
        ...this.filtros,
        anoFiscal: this.filtros.ano_fiscal,
      };

      if (this.filtros.id_grupo) {
        params.id_holding = this.filtros.id_grupo;
      }
      if (this.filtros.id_divisao) {
        params.id_divisao = this.filtros.id_divisao;
      }
      if (this.filtros.mes) {
        params.mes = this.filtros.mes;
      }
      if (this.filtros.id_tipo_verba) {
        params.id_tipo_verba = this.filtros.id_tipo_verba;
      }
      if (this.filtros.id_periodo) {
        params.id_periodo = this.filtros.id_periodo;
      }
      if (this.filtros.id_orcamento) {
        params.id_orcamento = this.filtros.id_orcamento;
      }
      if (this.filtros.id_acao_tipo) {
        params.id_acao_tipo = this.filtros.id_acao_tipo;
      }

      return params;
    },
  },
};
</script>
